<template>
  <div class="bulkActivateSiteModal position-relative">
    <div class="modal fade" id="bulkActivateSiteModal" tabindex="-1" role="dialog" aria-labelledby="bulkActivateSiteModal" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Bulk Activate Domains</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="loader" v-if="loading"></div>
            <template v-else-if="!loading & stepper === 1">
              <div  class="row pl-15 pr-15 mt-10">
                <div class="col-md-6 form-check-radio">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="selectedValue" type="radio" name="checkAllDomains" id="inputDomain" value="checkAll"> Select all domains
                    <span class="form-check-sign"></span>
                  </label>
                </div>
                <div class="col-md-6 form-check-radio">
                  <label class="form-check-label">
                    <input class="form-check-input" v-model="selectedValue" type="radio" name="uncheckAllDomains" id="status" value="uncheckAll"> Uncheck all domains
                    <span class="form-check-sign"></span>
                  </label>
                </div>
              </div>
              <div class="row mt-5">
                <perfect-scrollbar class="scroll-area col-md-12">
                  <table class="table single-outage-table">
                    <thead>
                    <tr>
                      <th><b>Domain Name</b></th>
                      <th class="text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, index) in accounts" :key="index">
                      <td>{{ row.domain }}  <i  v-if="row.disabledForUpdate" class="fa fa-question-circle text-primary" data-toggle="tooltip" data-placement="top" :title="row.message"></i> </td>
                      <td v-if="row.addonIndex === null">
                        <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center" >
                          <input type="checkbox" class="custom-control-input" :name="`${index}forPrimary`" v-model="checkAll" :value="row" :id="`${index}forPrimary`"  :disabled="row.disabledForUpdate" />
                          <label class="custom-control-label" :for="`${index}forPrimary`"></label>
                        </div>
                      </td>
                      <td v-else>
                        <div class="custom-control custom-checkbox mr-sm-2 d-flex justify-content-center">
                          <input type="checkbox" class="custom-control-input" name="identifiers" v-model="checkAll" :value="row" :id="index"  :disabled="row.disabledForUpdate"/>
                          <label class="custom-control-label" :for="index"></label>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </perfect-scrollbar>
              </div>
              <hr class="mt-20 mb-20">
              <div class="mt-5">
                <label class="fw-600">Select Action</label>
                <select class="form-control" v-model="selectedActionType">
                  <option v-for="action in actionOptions" :value="action" :key="action.text">
                    {{action.text}}
                  </option>
                </select>
              </div>
              <div class="mt-5">
                <button  class="btn btn-success pull-right" :disabled="!(selectedActionType.text && checkAll.length)" @click.prevent="stepper++">
                  <span >Next</span>
                </button>
              </div>
            </template>
            <template v-else>
              <div  class="row pl-15 pr-15 mt-10">
                <div class="col-md-12">
                  <div class="fw-500 fs-16 text-primary">Are you sure you want to perform the following action on the selected domains?</div>
                  <br>
                  <div class="mr-10 fw-600">Selected Action</div>
                  <input class="form-control" :value="selectedActionType.text" :disabled="true" />
                </div>
              </div>
              <div class="row mt-10">
                <div class="col-md-12">
                  <perfect-scrollbar class="scroll-area col-md-12">
                    <table class="table single-outage-table">
                      <thead>
                      <tr>
                        <th><b>Domain Name</b></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, index) in checkAll" :key="index"  >
                        <td>{{ row.domain }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </perfect-scrollbar>
                </div>
              </div>
              <hr class="mt-20 mb-20">
              <div class="mt-5">
                <button class="btn btn-success pull-right" :disabled="loading" @click.prevent="submit()">
                  <span>Activate</span>
                </button>
                <button  class="btn btn-danger pull-right" :disabled="loading" @click.prevent="stepper--">
                  <span>Back</span>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import swal from "sweetalert2";
import {db} from "@/firebase/init";
export default {
  name: "bulkActivateSiteModal",
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      parentAccounts: [],
      bulkActivateSiteModal: '',
      stepper: 1,
      selectedPlanIndex: null,
      checkAll: [],
      isPrimaryDisabled: false,
      isAddonDisabled: false,
      selectedValue: '',
      usingWithOutUsingFlag : 'using',
      loading: false,
      selectedFilteredCloudFareAccount: null,
      selectedActionType: {
        text: '',
        action: '',
      },
      actionOptions: [
        {text: 'Activate', action: 'activate'},
      ],
    }
  },

  computed: {
    custID() {
      return this.$store.getters["customer/id"];
    },
    customerInfo () {
      return this.$store.getters["customer/details"];
    },
    docID() {
      return this.$store.getters["customer/docID"];
    },
    accounts() {
      let hostingAccounts = this.$store.getters["hosting/accountsOrdered"];
      hostingAccounts = hostingAccounts.filter(acc => {
        if (!acc.deleted && acc.status !== 'active') {
          return acc;
        }
        return false;
      });
      return hostingAccounts
    },
    user() {
      return this.$store.getters.user;
    },
  },
  watch: {
    selectedValue (val) {
      if (val === 'checkAll') {
        for (const row of this.accounts) {
          const { status } = this.updateStatusCake(row);
          if(!status)
          this.checkAll.push(row)
        }
        this.selectedFilteredCloudFareAccount= null;
        this.usingWithOutUsingFlag = 'using'
      } else if (val === 'uncheckAll') {
        this.checkAll = [];
        this.selectedFilteredCloudFareAccount= null;
        this.usingWithOutUsingFlag = 'using'
      }
    },
  },
  mounted(){
    $('#bulkActivateSiteModal').on('hidden.bs.modal', this.handleModalHidden);
  },
  methods: {
    updateStatusCake(account) {
        let flag = false;
        let message = ''
        if(!account.domain || !account.serverIP || (!account.hbServiceID && account.type === 'Primary Domain') || (!account.solusVM_VPS_ID && account.type === 'Primary Domain') || (!account.hbHostname && account.type === 'Primary Domain') || (!account.phpMyAdmin.url && account.type === 'Primary Domain') ||
            !account.phpMyAdmin.password || !account.phpMyAdmin.username || (!account.phpMyAdmin.popupPassword && account.type === 'Primary Domain') || (!account.phpMyAdmin.popupUsername && account.type === 'Primary Domain') || (!account.backupUser && account.type === 'Primary Domain') || (!account.backupServer && account.type === 'Primary Domain')) {
          flag = true;
          if(!account.domain) {
            message = 'You cannot set this domain to active because domain field is empty.'
          } else if(!account.serverIP) {
            message = 'You cannot set this domain to active because serverIP field is empty.'
          } else if(!account.hbServiceID && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because hbServiceID field is empty.'
          } else if(!account.solusVM_VPS_ID && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because solusVM_VPS_ID field is empty.'
          } else if(!account.hbHostname && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because hbHostname field is empty.'
          } else if(!account.phpMyAdmin.url && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because phpMyAdmin url field is empty.'
          } else if(!account.phpMyAdmin.password) {
            message = 'You cannot set this domain to active because phpMyAdmin password field is empty.'
          } else if(!account.phpMyAdmin.username) {
            message = 'You cannot set this domain to active because phpMyAdmin username field is empty.'
          } else if(!account.phpMyAdmin.popupPassword && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because phpMyAdmin popupPassword field is empty.'
          } else if(!account.phpMyAdmin.popupUsername && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because phpMyAdmin popupUsername field is empty.'
          } else if(!account.backupUser && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because backupUser field is empty.'
          } else if(!account.backupServer && account.type === 'Primary Domain') {
            message = 'You cannot set this domain to active because backupServer field is empty.'
          }
        }
        if(flag) {
          account.status = 'pending'
          return {status: true, message,}
        }
      return {status: false}
      },
    handleModalHidden() {
      this.selectedValue ='uncheckAll';
    },
    async load() {
      this.checkAll = []
      this.stepper = 1
      this.selectedActionType = {
        text: '',
        action: '',
      }
      this.accounts.forEach(account => {
        const value = this.updateStatusCake(account);
        account.disabledForUpdate = value.status;
        account.message = account.disabledForUpdate ? value.message : '';
      })
      this.selectedValue ='checkAll';
      this.fixModal()
      $('#bulkActivateSiteModal').modal('show');
    },
    fixModal() {
      /* eslint-disable */
      $(document).ready(function() {
        $(".modal-backdrop").appendTo(".bulkActivateSiteModal");
      });
      /* eslint-enable */
    },
    async submit(){
      try {
        if (!this.checkAll.length) {
          return;
        }
        const domainList = this.checkAll.map(item => {
          return item.domain
        })
        console.log(domainList, 'this list')
        this.loading = true;
        const { data } = await this.$http.post('/status_cake/bulk_update_with_status',{
          grant_type: 'token',
          UID: this.docID,
          domainList,
          status: 'active',
        });
        this.loading = false
        if(data.failedDomains.length > 0) {
          await swal({
            title: 'Success',
            html: '<span style="color: red">Betteruptime status of the following domains were not updated</span><br/><br/>' +
                '<ul style="color: red">' +
                data.failedDomains.map(domain => `<li>${domain}</li>`).join('') +
                '</ul>',
            type: 'success'
          });
        }
        else{
          await swal('Success', 'Domains have been updated', 'success')
        }

        $("#bulkActivateSiteModal").modal('hide');
      }
      catch(e){
        this.loading = false
        console.log(e.toString(), 'Error Occurred while wrong removing domains')
        $("#bulkActivateSiteModal").modal('hide');
        await swal('Error', 'Something went wrong removing domains', 'error')
      }
    },
  },
}
</script>

<style scoped>

</style>


